/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { SEEN_PULSATING_FIELDS_BUTTON } from '../../../constants.tsx';
import type { Props, State } from '../../../types.tsx';
import { maybeWaitForPremiumModal } from '../../utils.tsx';

export const loadSeenPulsatingFieldsButton =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		// User property is already loaded
		if (typeof getState().projectFields.seenPulsatingFieldsButton === 'boolean') {
			return;
		}

		try {
			const seenPulsatingFieldsButton = await getUserProperty<boolean>(
				accountId,
				SEEN_PULSATING_FIELDS_BUTTON,
			);

			const state = getState();

			setState({
				...state,
				projectFields: {
					...state.projectFields,
					seenPulsatingFieldsButton,
				},
			});
		} catch (error) {
			// Expected error, the property is not set yet
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					...state,
					projectFields: {
						...state.projectFields,
						seenPulsatingFieldsButton: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.project-fields.pulsating-fields-button',
				`Failed to get user property with key: ${SEEN_PULSATING_FIELDS_BUTTON}`,
				error instanceof Error ? error : undefined,
			);
		}
	};

export const setSeenPulsatingFieldsButton =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			...state,
			projectFields: {
				...state.projectFields,
				seenPulsatingFieldsButton: true,
			},
		});

		try {
			await setUserProperties(accountId, SEEN_PULSATING_FIELDS_BUTTON, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.project-fields.pulsating-fields-button',
				`Failed to set user property with key: ${SEEN_PULSATING_FIELDS_BUTTON}`,
				error instanceof Error ? error : undefined,
			);
		}
	};
